// extracted by mini-css-extract-plugin
export default {"amenitiesRow":"summary_amenitiesRow__mzkuB","searchHeader":"summary_searchHeader__qVZGq"};